import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

// Overriding public url for review apps
export const BASE_URL = process.env.PUBLIC_URL || '/';

export const keycloakConfig: UserManagerSettings = {
  authority: process.env.REACT_APP_KEYCLOAK_URL!,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID!,
  redirect_uri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URI!,
  ui_locales: 'el',
  response_type: 'code',
  scope: 'openid profile roles',
  // https://authts.github.io/oidc-client-ts/interfaces/UserManagerSettings.html#automaticSilentRenew
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};
